'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _BaseIcon2 = require('./BaseIcon');

var _BaseIcon3 = _interopRequireDefault(_BaseIcon2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*eslint-disable */
var Home = function (_BaseIcon) {
  (0, _inherits3.default)(Home, _BaseIcon);

  function Home() {
    (0, _classCallCheck3.default)(this, Home);
    return (0, _possibleConstructorReturn3.default)(this, (Home.__proto__ || (0, _getPrototypeOf2.default)(Home)).apply(this, arguments));
  }

  (0, _createClass3.default)(Home, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'svg',
        this.getSvgProps(),
        _react2.default.createElement('path', (0, _extends3.default)({ d: 'M18.729266 17.535476v-5.7744791h.3913931c1.0360888 0 1.5198148-1.3196242.7419311-2.02233423l-7.0802124-6.4003813c-.4387853-.45104182-1.1496664-.45104182-1.5884516 0l-7.08021246 6.4003813c-.7778837.70271003-.2941577 2.02233423.7419311 2.02233423H5.247038v5.7744791c0 .6373416-.50333652 1.1545689-1.123519 1.1545689-.6201825 0-1.123519.5172273-1.123519 1.154569C3 20.4827727 3.5033365 21 4.123519 21h4.494076c.62099958 0 1.123519-.5172273 1.123519-1.1553861v-3.464524c0-.6373417.5033365-1.154569 1.123519-1.154569h2.247038c.6201825 0 1.123519.5172273 1.123519 1.154569v3.464524C14.23519 20.4827727 14.7385265 21 15.358709 21h4.494076c.6201825 0 1.123519-.5172273 1.123519-1.1553861 0-.6373417-.5033365-1.154569-1.123519-1.154569s-1.123519-.5172273-1.123519-1.1545689z'
        }, this.getPathProps()))
      );
    }
  }]);
  return Home;
}(_BaseIcon3.default);
/*eslint-enable */


Home.defaultProps = {
  width: 18,
  height: 18,
  viewBox: '3 3 18 18'
};
exports.default = Home;
//# sourceMappingURL=Home.js.map


//////////////////
// WEBPACK FOOTER
// ../icon/lib/Icons/Home.js
// module id = 299
// module chunks = 0